module.exports = __webpack_public_path__ + "4e3946529b75a176bd86d4decb6069d6.pdf";